var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-page-detail" },
    [
      _vm.isBoxless == "1"
        ? [_vm._t("default")]
        : [
            _c("title-block", { attrs: { title: _vm.pageTitle } }),
            _c("div", { staticClass: "box" }, [
              _c("div", { staticClass: "content" }, [_vm._t("default")], 2)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }